import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';
import { Recipient } from '@bonusly/recipient-entities';

export enum QueryKey {
	Recipients = 'recipients',
}

interface RecipientAPIResponse {
	can_receive: boolean;
	display_name: string;
	email: string | null;
	full_pic_url: string;
	group_type: 'username' | 'group';
	group_users: string[];
	id: string;
	profile_pic_url: string;
	user_mode: string;
	username: string;
}
interface AxiosResponse<T> {
	data: T;
}

interface GetRecipientsResponse {
	result: RecipientAPIResponse[];
	success: boolean;
}

export const useGetEveryoneRecipient = (options: UseQueryOptions<AxiosResponse<GetRecipientsResponse>, unknown, Recipient[]> = {}) => {
	const http = useHttpClient('v2');

	return useQuery<AxiosResponse<GetRecipientsResponse>, unknown, any>(
		[QueryKey.Recipients, 'everyone'],
		() =>
			http.get<GetRecipientsResponse>('/users/autocomplete', {
				params: { search: 'everyone' },
			}),
		{
			retry: false,
			refetchOnWindowFocus: false,
			select: (data) => {
				return data.data.result.map((recipient: RecipientAPIResponse) => {
					return {
						dimension: recipient.group_type,
						displayName: recipient.display_name,
						id: recipient.id,
						profilePic: recipient.full_pic_url,
						type: 'group',
						userIds: recipient.group_users.map((user: any) => user.id),
						username: recipient.username,
					};
				});
			},
			...options,
		}
	);
};
